import { useSelector } from "react-redux";
import PieChart from "common/Charts/PieChart/PieChart";
import {
  selectPortfolioDataLoadingStates,
  selectPortfolioPrecision,
  selectUniqueAccountsPortfolioData,
} from "@shared/slices/portfolio.slice";
import TextWithPrecisionAndIcon from "common/Text/TextWithPrecisionAndIcon";
import { PORTFOLIO_DATA_CLIENT_HEADER } from "@shared/features/portfolio/constants";
import { usePortfolioPieChart } from "@shared/features/portfolio/hooks";
import { LanguageNameSpaces, PrecisionType } from "@shared/types";
import { useBottomNavigator } from "utils/hooks/misc";
import React, { useMemo } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

export const AccountsPieChart = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const { loading } = useSelector(selectPortfolioDataLoadingStates);
  const { pieChartData, total } = usePortfolioPieChart({
    dataSelector: selectUniqueAccountsPortfolioData,
    nameHeader: PORTFOLIO_DATA_CLIENT_HEADER,
  });
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();

  const totalText = useMemo(
    () => (
      <TextWithPrecisionAndIcon
        precisionSelector={selectPortfolioPrecision}
        precisionType={PrecisionType.AMOUNT}
        text={total}
        round={true}
      />
    ),
    [total]
  );

  return (
    <PieChart
      data={pieChartData}
      loading={loading && (!isBottomNavigator || !pieChartData.length)}
      chartName={t("charts.accounts_allocation")}
      total={totalText}
      numGridItems={2}
      chartParentElementId="accounts-chart"
      tooltipElementId="accounts-chart-tooltip"
      isMobileMainPageChart={isBottomNavigator}
      isTwoLinesEllipsis={true}
    />
  );
};

export default React.memo(AccountsPieChart);
